import { Injectable, inject } from '@angular/core';
import { User } from '../../shared/models/user';
import {
  HttpClient,
  HttpContext,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Observable, of, firstValueFrom } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ServiceBase } from './service.base';
import { AppConstants } from '../../app.constants';
import {
  INTERCEPTNotFound,
  INTERCEPTUnauthorized,
} from '../interceptors/contexts';

@Injectable()
export class LoginService extends ServiceBase {
  protected http = inject(HttpClient);

  public login(email: string, password: string): Observable<User> {
    return new Observable<User>();
  }

  saveSession(data: User): void {
    this.authState?.setSession(data.access_token ?? '', data);
  }

  logout(): void {
    this.authState?.clearSession();
    localStorage.removeItem(AppConstants.KEYS_LOCAL_STORAGE.DATE_EXPIRES);
    localStorage.removeItem(AppConstants.KEYS_LOCAL_STORAGE.REFRESH_TOKEN);
    localStorage.removeItem(AppConstants.KEYS_LOCAL_STORAGE.ROLE);
    firstValueFrom(
      this.http.post(`${this.UrlServiceV1}auth/logout`, null, {
        withCredentials: true,
      }),
    ).catch(() => {});
  }

  silentRefresh(): Observable<boolean> {
    const headers = this.subscriptionKey
      ? new HttpHeaders({ 'Ocp-Apim-Subscription-Key': this.subscriptionKey })
      : new HttpHeaders();

    return this.http
      .get<{ access_token: string }>(`${this.UrlServiceV1}auth/refresh`, {
        withCredentials: true,
        headers,
        context: new HttpContext()
          .set(INTERCEPTNotFound, false)
          .set(INTERCEPTUnauthorized, false),
      })
      .pipe(
        map((response) => {
          const user = this.buildUserFromToken(response.access_token);
          this.saveSession(user);
          return true;
        }),
        catchError((err: HttpErrorResponse) => {
          if (err?.status === 401) {
            this.authState.clearSession();
          }
          return of(false);
        }),
      );
  }

  protected buildUserFromToken(token: string): User {
    const user = new User();
    user.access_token = token;
    return user;
  }
}
